import crearApiOrdenesRemito from "./apiOrdenesRemito";

const api = crearApiOrdenesRemito(
  "/ordencobroremito",
  "cliente"
);

export const postOrdenCobroRemito = api.crear;

export const getOrdenCobroRemito = api.obtener;

export const listOrdenesCobroRemito = api.listar;

export const getPendientesOrdenCobroRemito = api.pendientes;

export const getCreditosDisponiblesOrdenCobroRemito = api.creditos;

export const anularOrdenCobroRemito = api.anular;

export const putObservacionesOrdenCobroRemito =
  api.actualizarObservaciones;

export default api;